import React from "react"
import i18n from "i18n"
import { Checkbox, FormControlLabel, Grid, Switch } from "@mui/material"
import TextFieldNumber from "common/TextFieldNumber"
import Collapsable from "common/Collapsable"
import { useMarginsDiscounts } from "hooks/margin/useMarginsDiscounts"
import { EXTRA, GENERAL } from "context/margin/MarginsDiscountsReducer"

const DiscountTab = () => {
  const {
    state,
    setGeneralDiscount,
    setAddExtraDiscountPercentage,
    setOverrideDiscounts,
    setDiscountAccordionSelected,
  } = useMarginsDiscounts()
  return (
    <Grid container spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <Collapsable
            title={
              <FormControlLabel
                checked={state.discounts.accordionSelected === GENERAL}
                control={<Checkbox />}
                label={i18n.t("discountTab.addGeneralDiscountTitle")}
                sx={{ margin: 0 }}
                onChange={e => {
                  e.stopPropagation()
                  setDiscountAccordionSelected(GENERAL)
                }}
              />
            }
            expanded
          >
            <Grid container item spacing={2}>
              <Grid container item spacing={2}>
                <Grid item xs={6}>
                  <TextFieldNumber
                    disabled={state.discounts.accordionSelected !== GENERAL}
                    label={i18n.t("discountTab.addGeneralDiscount")}
                    value={state.discounts.generalDiscount}
                    onChange={e => setGeneralDiscount(e)}
                    isPercentage
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FormControlLabel
                    disabled
                    control={
                      <Switch
                        checked={state.discounts.overrideDiscounts}
                        onChange={event =>
                          setOverrideDiscounts(event.target.checked)
                        }
                        sx={{ marginRight: 1 }}
                      />
                    }
                    label={i18n.t("discountTab.overwrite")}
                    sx={{
                      alignItems: "center",
                      "& .MuiFormControlLabel-label": {
                        verticalAlign: "middle",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Collapsable>
        </Grid>
        <Grid item xs={12}>
          <Collapsable
            expanded
            title={
              <FormControlLabel
                checked={state.discounts.accordionSelected === EXTRA}
                control={<Checkbox />}
                label={i18n.t("discountTab.addExtraDiscount")}
                sx={{ margin: 0 }}
                onChange={() => {
                  setDiscountAccordionSelected(EXTRA)
                }}
              />
            }
          >
            <Grid container item spacing={2}>
              <Grid container item spacing={2}>
                <Grid item xs={6}>
                  <TextFieldNumber
                    disabled={state.discounts.accordionSelected !== EXTRA}
                    label={i18n.t("discountTab.addExtraDiscountPercentage")}
                    value={state.discounts.addExtraDiscountPercentage}
                    onChange={e => setAddExtraDiscountPercentage(e)}
                    isPercentage
                  />
                </Grid>
              </Grid>
            </Grid>
          </Collapsable>
        </Grid>
      </Grid>
    </Grid>
  )
}

DiscountTab.propTypes = {}

export default DiscountTab
